export default __webpack_public_path__ + "static/media/projTrack1Full.6b21e75c.png";